import { render } from "./SectionDetail.vue?vue&type=template&id=327ff408&scoped=true"
import script from "./SectionDetail.vue?vue&type=script&lang=js"
export * from "./SectionDetail.vue?vue&type=script&lang=js"

import "./SectionDetail.vue?vue&type=style&index=0&id=327ff408&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327ff408"]])

export default __exports__